export function getView(patient) {
  return patient ? 'Patient' : 'Person'
}
